import React from 'react';

const Footer = () => {
  return (
    <div style={{ textAlign: 'center', padding: '20px', fontSize: '14px' }}>
      <div>Copyright 2023 © MasterAccounting </div>
      <div>intern@mastertalks.tw</div>
      <div><a href="/terms-of-use">服務條款</a> / <a href="/privacy-policy">隱私權政策</a></div>
    </div>
  );
};

export default Footer;